import {Divider, Icon, view} from '@sail/ui';
import {qrCode, wallet} from '@sail/icons/react/Icon';
import {SelectionCard} from 'src/v2/components/common/SelectionCard';
import {Text} from 'src/v2/components/common';
import {message, useIntl} from '@sail/intl';

interface Props {
  onDirectDepositPress?: () => void;
  onConnectedWalletPress?: () => void;
}

const messages = {
  useConnectedWallet: message({
    id: 'crypto.payins.v2.wallet_select_list.use_connected_wallet',
    description: 'Label for option to use a previously connected wallet',
    defaultMessage: 'Use a connected wallet',
  }),
  directDeposit: message({
    id: 'crypto.payins.v2.wallet_select_list.direct_deposit',
    description:
      'Label for the direct deposit via QR code option in the wallet select UI',
    defaultMessage: 'Direct deposit via QR code',
  }),
  or: message({
    id: 'crypto.payins.v2.wallet_select_list.or_separator',
    description: 'Separator text between wallet list and secondary actions',
    defaultMessage: 'OR',
  }),
};

export const WalletSelectListSecondary = ({
  onDirectDepositPress,
  onConnectedWalletPress,
}: Props) => {
  const intl = useIntl();

  return (
    <>
      <view.div
        css={{
          stack: 'x',
          alignItems: 'center',
          gap: 'small',
        }}
      >
        <view.div css={{width: 'fill', stack: 'y'}}>
          <Divider />
        </view.div>
        <Text type="caption" css={{color: 'subdued'}}>
          {intl.formatMessage(messages.or)}
        </Text>
        <view.div css={{width: 'fill', stack: 'y'}}>
          <Divider />
        </view.div>
      </view.div>

      <view.div css={{stack: 'y', gapY: 'small'}} role="listbox">
        {onConnectedWalletPress ? (
          <SelectionCard
            icon={
              <Icon
                icon={wallet}
                appearance="contained"
                css={{width: 'medium', height: 'medium', padding: 'small'}}
              />
            }
            label={intl.formatMessage(messages.useConnectedWallet)}
            onSelect={onConnectedWalletPress}
          />
        ) : null}
        {onDirectDepositPress ? (
          <SelectionCard
            icon={
              <Icon
                icon={qrCode}
                appearance="contained"
                css={{width: 'medium', height: 'medium', padding: 'small'}}
              />
            }
            label={intl.formatMessage(messages.directDeposit)}
            onSelect={onDirectDepositPress}
          />
        ) : null}
      </view.div>
    </>
  );
};
